import React, { useState } from "react";
import { FaLongArrowAltLeft, FaLongArrowAltRight } from "react-icons/fa";

const ImageCarousel = ({ images }) => {
  const [startIndex, setStartIndex] = useState(0);

  const handleNext = () => {setStartIndex((prevIndex) => (prevIndex + 1) % images.length);};

  const handlePrev = () => {setStartIndex((prevIndex) =>prevIndex === 0 ? images.length - 1 : prevIndex - 1);};

  const visibleImages = [
    images[(startIndex + 0) % images.length],
    images[(startIndex + 1) % images.length],
    images[(startIndex + 2) % images.length],
    images[(startIndex + 3) % images.length],];

  return (
    <div className="md:px-16 max-w-screen-xl mx-auto flex flex-col space-y-4"> 
    
    {/* IMAGES SECTION */}
    <div className="flex overflow-hidden space-x-3">
    {visibleImages.map((img, index) => (
    <div key={index} className="flex-shrink-0 basis-full md:basis-[calc(33.333%-8px)] grow-0 overflow-hidden">
    <img src={img} alt={`Slide ${index + 1}`} className="w-full h-full object-cover"/></div>))}</div>

    {/* CONTROLS */}
    <div className="flex justify-between items-center">
    
    {/* DOTS NAVIGATION */}
    <div className="flex space-x-2">
    {images.map((_, index) => (
    <div key={index} onClick={() => setStartIndex(index)} className={`w-2 h-2 md:w-3 md:h-3 rounded-full cursor-pointer transition-all duration-300
    ${startIndex === index ? "bg-green shadow-md w-6 md:w-8" : "bg-blue bg-opacity-50 shadow-md"}`}></div>))}</div>

    {/* NAVIGATION ARROWS */}
    <div className="flex space-x-2">
    <button onClick={handlePrev} className="bg-transparent text-blue text-opacity-50 p-2 transition-all duration-300 hover:scale-125 hover:text-green">
    <FaLongArrowAltLeft className="w-4 h-4 md:w-6 md:h-6" /></button>
    
    <button onClick={handleNext} className="bg-transparent text-blue text-opacity-50 p-2 transition-all duration-300 hover:scale-125 hover:text-green">
    <FaLongArrowAltRight className="w-4 h-4 md:w-6 md:h-6" /></button></div></div></div>);};

export default ImageCarousel;
